import mapboxgl from 'mapbox-gl';

$(function() {
    mapboxgl.accessToken = 'pk.eyJ1IjoiYmxhY2tkZXNrIiwiYSI6ImNrbWttMW1ucTEyYm4yd25haXVwcHI3cWMifQ.4RJo9e-1PzcMOxHr64PA2w';

    const mapbox = $('.mapbox');
    if (!mapbox.length || !mapbox.data('lng') || !mapbox.data('lat')) {
        return;
    }

    const map = new mapboxgl.Map({
        container: mapbox.get(0),
        // TODO vervang standaard blackdesk mapbox style URL voor URL van de website zelf
        style: 'mapbox://styles/blackdesk/ckl0qklub0sjr17s0j3cw1rmy',
        center: new mapboxgl.LngLat(mapbox.data('lng'), mapbox.data('lat')),
        maxZoom: 18,
        zoom: 12,
        minZoom: 6,
    });

    const markers = $('.mapbox__marker');
    markers.each(function () {
        if (!$(this).data('lng') || !$(this).data('lat')) {
            return;
        }
        const markerPosition = new mapboxgl.LngLat($(this).data('lng'), $(this).data('lat'));
        const marker = document.createElement('div');
        marker.className = 'marker';
        // marker.style.backgroundImage = `url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20384%20512%22%3E%3Cpath%20fill%3D%22white%22%20d%3D%22M172.268%20501.67C26.97%20291.031%200%20269.413%200%20192%200%2085.961%2085.961%200%20192%200s192%2085.961%20192%20192c0%2077.413-26.97%2099.031-172.268%20309.67-9.535%2013.774-29.93%2013.773-39.464%200zM192%20272c44.183%200%2080-35.817%2080-80s-35.817-80-80-80-80%2035.817-80%2080%2035.817%2080%2080%2080z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E%0A')`;
        marker.style.backgroundImage = 'url(/wp-content/themes/compagnonkaastheme/resources/images/mapbox_marker.svg)';
        const size = 50;
        marker.style.width = size + 'px';
        marker.style.height = size + 'px';
        marker.style.top = '-' + size / 2 + 'px';
        marker.style.backgroundSize = 'contain';
        marker.style.backgroundRepeat = 'no-repeat';
        marker.style.backgroundPosition = 'center center';
        new mapboxgl.Marker(marker).setLngLat(markerPosition).addTo(map);
    });
});
